module.exports = __webpack_public_path__ + "img/operation_a.556a15eb.png";